import React, { useState } from 'react';
import './Contact.css';

const initialFormData = {
  name: '',
  email: '',
  subject: '',
  message: ''
};

const defaultErrorMessage = 'Failed to send message. Please try again.';

const Contact = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.success) {
        throw new Error(data.error || defaultErrorMessage);
      }

      setFormData(initialFormData);
      setSuccessMessage('Message sent successfully.');
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message || defaultErrorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact">
      <div className="contact-inner">
        <div className="contact-left">
          <h1 className="page-title">Contact</h1>
          <p className="contact-intro">Reach out via the form or find me on:</p>
          <div className="contact-links">
            <a href="https://github.com/jericho0521" target="_blank" rel="noopener noreferrer" className="arrow-link">
              <span className="arrow">-&gt;</span> GitHub
            </a>
            <a href="https://linkedin.com/in/jerichofoong" target="_blank" rel="noopener noreferrer" className="arrow-link">
              <span className="arrow">-&gt;</span> LinkedIn
            </a>
          </div>
        </div>

        <div className="contact-right">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                required
              ></textarea>
            </div>
            {(successMessage || errorMessage) && (
              <p
                className={`form-status ${successMessage ? 'form-status-success' : 'form-status-error'}`}
                role={errorMessage ? 'alert' : 'status'}
              >
                {successMessage || errorMessage}
              </p>
            )}
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send ->'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
